// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.style_main_container_card_save__ZZfG9 input:checked, .style_pagination__\\+8O97 button, .style_pagination__\\+8O97 div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_main_container_card_save__ZZfG9, .style_interface_heading_row__LcgKX {
  display: flex;
  align-items: center;
}

.style_interface_noResults__7gnAl {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_interface__1zafN {
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
}

.style_link__ds6T6 {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__ds6T6:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__uVjmJ {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__kuqeY {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__1f5nr, .style_interface_heading__hK6Rz, .style_interface_footer__9om\\+s {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__weMd9 {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__qlcq0 {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__qlcq0 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__8YkwH {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__8YkwH {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__6AZw- {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__6AZw- {
    line-height: 1.5rem;
  }
}

.style_breadcumb__abN0S {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__abN0S a,
.style_breadcumb__abN0S span {
  padding: 3px 5px;
}
.style_breadcumb__abN0S a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__abN0S a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__abN0S .style_divider__jB9O9 {
  color: var(--color-gray-400);
}

.style_badge__EeBX2 {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__EeBX2.style_xs__IunTA {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__EeBX2.style_sm__5X5iT {
  padding: 4px 7px;
}
.style_badge__EeBX2.style_primary__oNN2m {
  background: var(--color-primary-500);
}
.style_badge__EeBX2.style_primary__oNN2m, .style_badge__EeBX2.style_pm__Ii8uj {
  background: var(--color-primary-500);
}
.style_badge__EeBX2.style_sd__jMcka {
  background-color: var(--color-secundary-500);
}
.style_badge__EeBX2.style_Likely__yvE-t {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__EeBX2.style_Unvalidated__EiiGS {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__EeBX2.style_Verified__oQMq3, .style_badge__EeBX2.style_green__8eacN {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__EeBX2.style_off__voTZZ {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__yc6rT {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__yc6rT.style_xs__IunTA {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__yc6rT.style_sm__5X5iT {
  padding: 4px 7px;
}
.style_badgeTable__yc6rT.style_primary__oNN2m, .style_badgeTable__yc6rT.style_pm__Ii8uj {
  background: var(--color-primary-500);
}
.style_badgeTable__yc6rT.style_sd__jMcka {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__yc6rT.style_Likely__yvE-t {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__yc6rT.style_Verified__oQMq3, .style_badgeTable__yc6rT.style_green__8eacN {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__yc6rT.style_off__voTZZ {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__dxj2P {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__dxj2P.style_style-1__jkZV1 td,
.style_table__dxj2P.style_style-1__jkZV1 th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__dxj2P.style_style-1__jkZV1 th,
.style_table__dxj2P.style_style-1__jkZV1 td.style_label__5hPuc {
  color: var(--color-white-500);
}
.style_table__dxj2P.style_style-1__jkZV1 th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__dxj2P.style_style-1__jkZV1 tr.style_noBorder__D7pMM td {
  border-bottom: none;
}
.style_table__dxj2P.style_style-1__jkZV1 tr td {
  color: var(--color-white-500);
}

.style_pagination__\\+8O97 {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__\\+8O97 button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__\\+8O97 button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__\\+8O97 button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__\\+8O97 button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__\\+8O97 button.style_disabled__E\\+GLy, .style_pagination__\\+8O97 button.style_active__Kmx3U, .style_pagination__\\+8O97 button.style_info__3zV8o {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__\\+8O97 button.style_disabled__E\\+GLy {
  color: var(--color-gray-700);
}
.style_pagination__\\+8O97 div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__\\+8O97 div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__\\+8O97 div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__\\+8O97 div:hover, .style_pagination__\\+8O97 div.style_active__Kmx3U {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__\\+8O97 div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__\\+8O97 div.style_disabled__E\\+GLy, .style_pagination__\\+8O97 div.style_active__Kmx3U, .style_pagination__\\+8O97 div.style_info__3zV8o {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__\\+8O97 div.style_disabled__E\\+GLy {
  color: var(--color-gray-700);
}
.style_pagination__\\+8O97 div:last-child, .style_pagination__\\+8O97 div:first-child {
  padding: 0 10px;
}
.style_pagination__\\+8O97 div:last-child {
  border-right: none;
}
.style_pagination__\\+8O97 button:last-child, .style_pagination__\\+8O97 button:first-child {
  padding: 0 10px;
}
.style_pagination__\\+8O97 button:last-child {
  border-right: none;
}

.style_interface__1zafN {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__hK6Rz {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__hK6Rz {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__hK6Rz > div {
    width: 100%;
  }
}
.style_interface_heading_row__LcgKX {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__LcgKX {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__9om\\+s {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__9om\\+s {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__9om\\+s > div {
    width: 100%;
  }
}
.style_interface_foot__wgtkS {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__wgtkS {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__7gnAl {
  gap: 15px;
  padding: 70px 0;
}

.style_main__-GXo- {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.style_main_container__r6Fx\\+ {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
@media only screen and (max-width: 450px) {
  .style_main_container__r6Fx\\+ {
    padding: 25px 17px;
  }
}
.style_main_container_allCards__TRCz1 {
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.style_main_container_allCards_heightLimited__q\\+03n {
  max-height: 340px;
  overflow: auto;
}
.style_main_container_allCards_actions__ju-Yc {
  display: flex;
  align-items: flex-start;
}
.style_main_container_allCards_actions__ju-Yc button {
  font-size: 15px;
  width: max-content;
}
.style_main_container_card__BiiyA {
  position: relative;
  gap: 16px;
  display: flex;
  flex-direction: column;
}
.style_main_container_card_inputBox__DqFNR {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
}
.style_main_container_card_inputBox__DqFNR label {
  color: var(--color-white-500);
}
.style_main_container_card_inputBox__DqFNR fieldset {
  background-color: var(--color-paper-400);
  border: 1px solid var(--color-gray-700);
  margin-top: 7px;
  border-radius: 8px;
  padding: 10px 14px;
}
.style_main_container_card_row__anoy1 {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.style_main_container_card_save__ZZfG9 {
  gap: 8px;
  cursor: pointer;
  z-index: 10;
  width: max-content;
}
.style_main_container_card_save__ZZfG9 input[type=checkbox] {
  appearance: none;
  width: 16px;
  height: 16px;
  background-color: var(--color-gray-800);
  border: 1px solid var(--color-gray-700);
  border-radius: 3px;
}
.style_main_container_card_save__ZZfG9 input:checked {
  background-color: var(--main-color);
  position: relative;
}
.style_main_container_card_save__ZZfG9 input:checked::before {
  content: "✓";
  color: #fff;
  padding: 5px;
}
.style_main_container_card_save__ZZfG9 span {
  font-size: 12px;
  color: var(--color-white-500);
}
.style_main_container_card_actions__7YH4C button {
  width: max-content;
}
.style_main_container_card_actions__7YH4C button:hover:not([disabled]) {
  background: linear-gradient(var(--main-color), rgba(0, 0, 0, 0.7)) top/100% 900%;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/PaymentMethod/style.module.scss","webpack://./src/assets/scss/_flex.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ADEF;;ACCA;EACE,aAAA;EACA,mBAAA;ADEF;;ACYA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ADTF;;AC4BA;EACE,aAAA;EACA,sBAAA;ADzBF;;AEdA;EACI,qBAAA;AFiBJ;;AEfA;EACI,eAAA;EACA,cAAA;AFkBJ;AEjBI;EACE,0BAAA;AFmBN;;AEfA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AFkBJ;;AEfI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;AFkBR;AEhBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;AFkBR;AEhBI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;AFkBR;AEhBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AFkBR;AG1DE;EDsCE;IAIQ,eAAA;IACA,mBAAA;EFoBV;AACF;AElBI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AFoBR;AGpEE;ED8CE;IAIQ,eAAA;IACA,mBAAA;EFsBV;AACF;AEpBI;EACI,mBAAA;AFsBR;AG7EE;EDsDE;IAGQ,mBAAA;EFwBV;AACF;;AIhFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AJmFF;AIlFE;;EAEE,gBAAA;AJoFJ;AIlFE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AJoFJ;AInFI;EACE,+BAAA;EACA,uCAAA;AJqFN;AIlFE;EACE,4BAAA;AJoFJ;;AKxGA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AL2GF;AKxGE;EACE,gBAAA;EACA,eAAA;AL0GJ;AKxGE;EACE,gBAAA;AL0GJ;AKtGE;EACE,oCAAA;ALwGJ;AKtGE;EAEE,oCAAA;ALuGJ;AKrGE;EACE,4CAAA;ALuGJ;AKrGE;EACE,uCAAA;EACA,mCAAA;ALuGJ;AKrGE;EACE,oCAAA;EACA,gCAAA;ALuGJ;AKrGE;EAEE,4CAAA;EACA,kCAAA;ALsGJ;AKpGE;EACE,6BAAA;EACA,uCAAA;ALsGJ;;AKnGA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;ALsGF;AKnGE;EACE,gBAAA;EACA,eAAA;ALqGJ;AKnGE;EACE,gBAAA;ALqGJ;AKjGE;EAEE,oCAAA;ALkGJ;AKhGE;EACE,4CAAA;ALkGJ;AKhGE;EACE,mBAAA;EACA,cAAA;ALkGJ;AKhGE;EAEE,4CAAA;EACA,kCAAA;ALiGJ;AK/FE;EACE,6BAAA;EACA,uCAAA;ALiGJ;;AMzLA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;AN4LF;AM1LI;;EAEE,kBAAA;EACA,mBAAA;AN4LN;AM1LI;;EAEE,6BAAA;AN4LN;AM1LI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;AN4LN;AMzLM;EACE,mBAAA;AN2LR;AMzLM;EACE,6BAAA;AN2LR;;AO/MA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;APiNJ;AO/MI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;APgNR;AO/MQ;EACI,2BAAA;EACA,8BAAA;APiNZ;AO/MQ;EACI,4BAAA;EACA,+BAAA;APiNZ;AGhPE;EIgBE;IAkBQ,eAAA;IACA,eAAA;EPkNV;AACF;AOjNQ;EACI,eAAA;EACA,oBAAA;APmNZ;AOjNQ;EACI,4BAAA;APmNZ;AOhNI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;APiNR;AOhNQ;EACI,2BAAA;EACA,8BAAA;APkNZ;AOhNQ;EACI,4BAAA;EACA,+BAAA;APkNZ;AOhNQ;ECrCJ,eAAA;EACA,qFAAA;ARwPJ;AGlRE;EI6CE;IAqBQ,eAAA;IACA,eAAA;EPoNV;AACF;AOnNQ;EACI,eAAA;EACA,oBAAA;APqNZ;AOnNQ;EACI,4BAAA;APqNZ;AOlNI;EACI,eAAA;APoNR;AOlNI;EACI,kBAAA;APoNR;AOlNI;EACI,eAAA;APoNR;AOlNI;EACI,kBAAA;APoNR;;AStSA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;ATySF;ASvSE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ATwSJ;AGhUE;EMeA;IAWI,kBAAA;IACA,uBAAA;ET0SJ;ESzSI;IACE,WAAA;ET2SN;AACF;ASzSI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;AT0SN;AG9UE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ET4SN;AACF;ASzSE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AT0SJ;AG9VE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ET4SJ;ES3SI;IACE,WAAA;ET6SN;AACF;AS1SE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AT4SJ;AG5WE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ET8SJ;AACF;AS5SE;EAEE,SAAA;EACA,eAAA;AT6SJ;;AArXA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAwXF;AAvXE;EAGE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAuXJ;AGnYE;EHMA;IAOoB,kBAAA;EA0XpB;AACF;AA1XI;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA4XN;AA3XM;EACE,iBAAA;EACA,cAAA;AA6XR;AA3XM;EACE,aAAA;EACA,uBAAA;AA6XR;AA5XQ;EACE,eAAA;EAAiB,kBAAA;AA+X3B;AA3XI;EACE,kBAAA;EAEA,SAAA;EACA,aAAA;EACA,sBAAA;AA4XN;AAhXM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AAkXR;AAjXQ;EAAQ,6BAAA;AAoXhB;AAnXQ;EACE,wCAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAqXV;AAlXM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAoXR;AAlXM;EAEE,QAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAmXR;AAlXQ;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,uCAAA;EACA,kBAAA;AAoXV;AAjXQ;EACE,mCUpFG;EVqFH,kBAAA;AAmXV;AA/WQ;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAiXV;AA9WQ;EACE,eAAA;EACA,6BAAA;AAgXV;AA3WQ;EACE,kBAAA;AA6WV;AA5WU;EACE,gFAAA;AA8WZ","sourcesContent":["@use \"/src/assets/scss/\" as *;\n\n.main {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  &_container {\n    // padding: 24px;\n    // background-color: var(--color-paper-500);\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    @include mobile { padding: 25px 17px; }\n    &_allCards {\n      overflow: auto;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      &_heightLimited {\n        max-height: 340px;\n        overflow: auto;\n      }\n      &_actions {\n        display: flex;\n        align-items: flex-start;\n        button {\n          font-size: 15px; width: max-content;\n        }\n      }\n    }\n    &_card {\n      position: relative;\n      // padding: 20px 0;\n      gap: 16px;\n      display: flex;\n      flex-direction: column;\n      // &::before {\n      //   content: \"\";\n      //   position: absolute;\n      //   inset: 0;\n      //   border-radius: 8px;\n      //   padding: 1px;\n      //   background: $gradient;\n      //   -webkit-mask: $gradient-border content-box, $gradient-border;\n      //   -webkit-mask-composite: xor;\n      //   mask-composite: exclude;\n      // }\n      &_inputBox {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        gap: 4px;\n        label { color: var(--color-white-500); }\n        fieldset {\n          background-color: var(--color-paper-400);\n          border: 1px solid  var(--color-gray-700);\n          margin-top: 7px;\n          border-radius: 8px;\n          padding: 10px 14px;\n        }\n      }\n      &_row {\n        display: flex;\n        justify-content: space-between;\n        gap: 16px;\n      }\n      &_save {\n        @extend %flex-align;\n        gap: 8px;\n        cursor: pointer;\n        z-index: 10;\n        width: max-content;\n        input[type=\"checkbox\"] {\n          -webkit-appearance: none;\n          appearance: none;\n          width: 16px;\n          height: 16px;\n          background-color: var(--color-gray-800);\n          border: 1px solid var(--color-gray-700);\n          border-radius: 3px;\n        }\n\n        input:checked {\n          background-color: $main-color;\n          position: relative;\n          @extend %flex-center;\n        }\n\n        input:checked::before {\n          content: \"✓\";\n          color: #fff;\n          padding: 5px;\n        }\n\n        span {\n          font-size: 12px;\n          color: var(--color-white-500);\n        }\n      }\n\n      &_actions {\n        button {\n          width: max-content;\n          &:hover:not([disabled]) {\n            background: linear-gradient($main-color, rgb(0 0 0/70%)) top/100% 900%;\n          }\n        }\n      }\n    }\n  }\n}\n","%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_container_card_save": `style_main_container_card_save__ZZfG9`,
	"pagination": `style_pagination__+8O97`,
	"interface_heading_row": `style_interface_heading_row__LcgKX`,
	"interface_noResults": `style_interface_noResults__7gnAl`,
	"interface": `style_interface__1zafN`,
	"link": `style_link__ds6T6`,
	"text-gradient-intel": `style_text-gradient-intel__uVjmJ`,
	"text-xs": `style_text-xs__kuqeY`,
	"text-sm": `style_text-sm__1f5nr`,
	"interface_heading": `style_interface_heading__hK6Rz`,
	"interface_footer": `style_interface_footer__9om+s`,
	"text-base": `style_text-base__weMd9`,
	"text-lg": `style_text-lg__qlcq0`,
	"text-xl": `style_text-xl__8YkwH`,
	"text-leading": `style_text-leading__6AZw-`,
	"breadcumb": `style_breadcumb__abN0S`,
	"divider": `style_divider__jB9O9`,
	"badge": `style_badge__EeBX2`,
	"xs": `style_xs__IunTA`,
	"sm": `style_sm__5X5iT`,
	"primary": `style_primary__oNN2m`,
	"pm": `style_pm__Ii8uj`,
	"sd": `style_sd__jMcka`,
	"Likely": `style_Likely__yvE-t`,
	"Unvalidated": `style_Unvalidated__EiiGS`,
	"Verified": `style_Verified__oQMq3`,
	"green": `style_green__8eacN`,
	"off": `style_off__voTZZ`,
	"badgeTable": `style_badgeTable__yc6rT`,
	"table": `style_table__dxj2P`,
	"style-1": `style_style-1__jkZV1`,
	"label": `style_label__5hPuc`,
	"noBorder": `style_noBorder__D7pMM`,
	"disabled": `style_disabled__E+GLy`,
	"active": `style_active__Kmx3U`,
	"info": `style_info__3zV8o`,
	"interface_foot": `style_interface_foot__wgtkS`,
	"main": `style_main__-GXo-`,
	"main_container": `style_main_container__r6Fx+`,
	"main_container_allCards": `style_main_container_allCards__TRCz1`,
	"main_container_allCards_heightLimited": `style_main_container_allCards_heightLimited__q+03n`,
	"main_container_allCards_actions": `style_main_container_allCards_actions__ju-Yc`,
	"main_container_card": `style_main_container_card__BiiyA`,
	"main_container_card_inputBox": `style_main_container_card_inputBox__DqFNR`,
	"main_container_card_row": `style_main_container_card_row__anoy1`,
	"main_container_card_actions": `style_main_container_card_actions__7YH4C`
};
export default ___CSS_LOADER_EXPORT___;
